// synced from loomweb blocks/web-search-block-view.tsx (de-Tailwind'd).
/**
 * Web-search block. Faithful to loomweb's WebSearchBlockView: header (icon +
 * "Web Search" + in-progress / Done state), an optional active-text row, and the
 * query. Tailwind classes are replaced by namespaced `replay-*` CSS; lucide icons
 * by the local inline-SVG set.
 */
import type { JSX } from "react";
import type { WebSearchBlock } from "@shared/loom-message-block";
import { SearchIcon, LoaderIcon, CheckIcon } from "./icons";

export function WebSearchBlockView({ block }: { block: WebSearchBlock }): JSX.Element {
  const isInProgress = block.status === "in_progress" || block.status === "streaming";
  const isCompleted = block.status === "completed";

  return (
    <div className="replay-block replay-web-search-block">
      <div className="replay-block-head">
        <SearchIcon className="replay-icon replay-text-cyan" />
        <span className="replay-block-label">Web Search</span>
        {isInProgress && (
          <span className="replay-block-flag replay-text-primary">
            <LoaderIcon className="replay-icon-xs replay-spin" />
          </span>
        )}
        {isCompleted && (
          <span className="replay-block-flag replay-text-success">
            <CheckIcon className="replay-icon-xs" />
            Done
          </span>
        )}
      </div>

      {isInProgress && block.activeText !== undefined && block.activeText.length > 0 && (
        <div className="replay-block-active">{block.activeText}</div>
      )}

      <div className="replay-query-body">
        <span className="replay-text-muted replay-mr-1">Search:</span>
        {block.query}
      </div>
    </div>
  );
}
